<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="panel">
        <div class="panel-hdr">
          <h1 class="subheader-title">
            <i class="subheader-icon fal fa-life-ring"></i> Помощь
          </h1>
        </div>
        <div class="panel-container show">
          <div class="panel-container show" v-if="loading">
            <div class="panel-content p-6 m-6">
              <content-placeholders :centered="true">
                <content-placeholders-text :lines="4" />
              </content-placeholders>
            </div>
          </div>
          <div data-form="support" class="panel-content" v-if="!loading">
            <div class="panel-tag mb-3" data-element="notification" v-html="notification"></div>
            <div class="form-group">
              <label class="form-label">Сообщение</label>
              <textarea data-input="text" class="form-control" v-focus rows="7" v-bind:class="{ 'is-invalid': 'text' in errors}" v-on:focus="$delete(errors, 'text')" v-model="text"></textarea>
              <div class="invalid-feedback" v-if="'text' in errors">{{ errors['text'] }}</div>
            </div>
            <button @click="sendMessage" data-button="send" class="btn btn-success">Отправить</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      title: 'Помощь',
    },
    data() {
      return {
        // Статус загрузки
        loading: true,
        // Данные пользователя
        user: {},
        // Ошибки
        errors: {},
        // Текст сообщения
        text: '',
        // Уведомление
        notification: ''
      };
    },
    watch: {
      user: function (user) {
        this.notification = 'Отправьте нам сообщение и мы ответим Вам на почтовый ящик '+user.mail+' в течение 24 часов.'
      }
    },
    methods: {
      // Получение данных пользователя
      getUser () 
      {
        this.$axios.get(process.env.VUE_APP_API_URL+'/v1/users').then(response =>
        {
          this.user = response.data.data;
          this.loading = false;
        });
      },
      // Изменение пользователя
      sendMessage () 
      {
        this.$axios.post(process.env.VUE_APP_API_URL+'/v1/support/mail', {mail: this.user.mail, name: this.user.firstname+' '+this.user.lastname, text: this.text}).then(response =>
        {
          if(response.data.status == 'success')
          {
            this.notification = 'Сообщение <b>отправлено</b>, мы ответим на него в течение 24 часов.';
            this.text = '';
          }
          else
            this.notification = 'Произошла ошибка, свяжитесь с нами самостоятельно по адресу er@lite.company.'
        }).catch(error => {
          // Собираем ошибки
          this.errors = {};
          $.each(error.response.data.errors, function(index, value) 
          {
            this.$set(this.errors, index, value[0])
          }.bind(this));
        });
      },
    },
    // Подгрузка данных
    mounted () 
    {
      this.getUser();
    },
  }
</script>